import * as React from "react";

import useUpdateSyllabusStudentProgress from "../../hooks/syllabi/updateSyllabusStudentProgress";
import useFetchSyllabusStudentProgress from "../../hooks/syllabi/useFetchSyllabusStudentProgress";
import { StudentProgressStatus, Syllabus, Move, User } from "../../types";

import ToggleInput, { ToggleInputProps } from "../common/ToggleInput";

const OPTIONS = Object.values(StudentProgressStatus);

export interface StudentProgressInputProps extends ToggleInputProps {
  syllabusId: Syllabus["id"];
  moveId: Move["id"];
  learnerId?: User["id"];
  disabled?: boolean;
}

function StudentProgressInput({
  syllabusId,
  moveId,
  learnerId,
  disabled,
  ...rest
}: StudentProgressInputProps) {
  const { mutate: updateProgress, isLoading: isUpdating } =
    useUpdateSyllabusStudentProgress();
  const { data: progress, isLoading } = useFetchSyllabusStudentProgress(
    syllabusId,
    moveId,
    learnerId
  );
  const { status } = progress || {};

  return (
    <ToggleInput
      {...rest}
      value={status || StudentProgressStatus.NotStarted}
      options={OPTIONS}
      disabled={disabled || isLoading || !progress}
      layout="column"
      onChange={(nextStatus) =>
        updateProgress({
          syllabusId,
          moveId,
          status: nextStatus as StudentProgressStatus,
        })
      }
    />
  );
}

export default StudentProgressInput;
